import SettingPage from "@features/settings/pages/settings-page";
import { ListCity } from "@/features/settings/citys/CitysList";
import { AdminRoute } from '@shared/guards/RoleBasedGuards';
import Settings from "@/features/settings/Settings";
import { CustomPricingManagement } from "@/features/settings/custom-pricing/CustomPricingManagement";

export const settingsRoutes = {
  path: "/settings",
  element: (
    <AdminRoute>
      <SettingPage />
    </AdminRoute>
  ),
  children: [
    { path: "/settings", element: <Settings /> },
    { path: "/settings/cities", element: <ListCity /> },
  ],
};
